/**
 * «После деплоя перезагрузка только на карте» (docs/PATH-V2.md §12.4, fixer r1): the commit of the server this page
 * first talked to (`GET /api/health` → `build.gitSha`) is remembered; the map — the one screen where a reload loses
 * nothing (no lesson, no game in progress) — asks the server again when it opens or comes back into view and reloads
 * the page when the server now runs another commit (the new bundle comes with it). Never in the middle of a lesson.
 */
import type { HealthInfo } from '@gambit/shared';

let first: string | null | undefined;

/** The first health answer of this page sets the commit it runs against (later answers change nothing). */
export function noteServerBuild(health: Pick<HealthInfo, 'build'> | null | undefined): void {
  if (first !== undefined || !health?.build) return;
  first = health.build.gitSha ?? null;
}

/** Does the server now run another commit than the one this page started with (both known)? */
export function serverBuildChanged(health: Pick<HealthInfo, 'build'> | null | undefined): boolean {
  const now = health?.build?.gitSha ?? null;
  return first !== undefined && first !== null && now !== null && now !== first;
}

/** Tests only. */
export function resetServerBuildForTest(): void {
  first = undefined;
}
